import { render, staticRenderFns } from "./OperacoesCdaWa.vue?vue&type=template&id=50e84b09&lang=pug"
import script from "./OperacoesCdaWa.vue?vue&type=script&lang=js"
export * from "./OperacoesCdaWa.vue?vue&type=script&lang=js"
import style0 from "./OperacoesCdaWa.vue?vue&type=style&index=0&id=50e84b09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports